<template>
  <div class="nesting__dialog--confirm" :class="{'nesting__dialog--confirm--show': active}">
  <!-- hide second dialog so the illustration image will load before its needed -->
    <div class="nesting__illustration">
      <BannerLogo class="nesting__illustration--background" alt=""/>
      <div class="nesting__illustration__destination">
        <AvatarImage :customSize="isMobile ? '30px' : '40px'"
                     :image-path="client.photo_path"
                     :name="client.full_name"
                     :color-id="client.color_id"/>
        <p class="nesting__illustration__destination--name">{{client.full_name}}</p>
        <p class="nesting__illustration__destination--email">{{client.email}}</p>
      </div>
      <div class="nesting__illustration__matter">
        <span class="nesting__illustration__matter--icon"><v-icon>{{businessTerm.icon}}</v-icon></span> {{matterName}}
      </div>
    </div>
    <p class="nesting__description" v-html="confirmMessage"/>
    <VAlert
      :value="deleteWarning"
      icon="icon-Warning"
      class="nesting__dialog--alert"
      color="#FFF7E0"
      border="left" >

      <v-layout align-start column>
        <p class="nesting__dialog--alert-text" v-html="alertMessage"/>
      </v-layout>
    </VAlert>
  </div>
</template>

<script>
import AvatarImage from "@/modules/common/components/AvatarImage/AvatarImage";

export default {
  name: "ConfirmNesting",
  components: {
    AvatarImage,
    BannerLogo: () => import(`@/assets/images/nest_confirm.svg`),
  },
  props: {
    client: {
      type: Object,
      required: true
    },
    matterName: {
      type: String,
      required: true
    },
    clientEmail: {
      type: String,
      required: false
    },
    confirmMessage: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    deleteWarning: {
      type: Boolean,
      default: true
    },
    isMobile: {
      type: Boolean,
      default: true
    },
    businessTerm: {
      type: Object,
      required: true
    }
  },
  computed: {
    clientParsedEmail() {
      return this.clientEmail ? `(${this.clientEmail})` : '';
    },
    alertMessage() {
      return this.$t('client.matters.matter_page.nesting_dialog.confirm.alert',{matter_full_name: this.matterName, client_email: this.clientParsedEmail});
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.nesting {

  &__dialog {

    &--confirm {
      text-align: center;
      width: 444px;
      margin: auto;
      display: none;

      &--show {
        display: block;
      }

      @include sm-and-down {
        width: 327px;
      }
    }

    &--alert {
      font-size: 11px;
      text-align: start;
      line-height: 18px;
      padding: 8px;
      margin-block: 16px 0;

      &-text {
        margin: 0;
      }

      ::v-deep {

        .v-alert__border {
          border-color: $orange-color-2;
          opacity: 1;
          border-width: 2px;
        }

        .v-icon {
          color: $orange-color-2;
          font-size: 20px;
          width: 20px;
          height: 20px;
          margin-right: unset;
          margin-inline: 4px 16px;
        }
      }
    }
  }

  &__illustration {
    position: relative;
    margin: auto;
    width: 100%;
    max-width: 450px;

    &--background {
      width: 100%;
      overflow: visible;
      transform: translateX(10px);

      @include sm-and-down {
        transform: translateX(-30px);
      }
    }

    &__destination {
      position: absolute;
      top: 13%;
      left: 13%;
      width: 39%;
      display: flex;
      flex-direction: column;
      align-items: center;

      @include sm-and-down {
        top: 10%;

        ::v-deep .avatar-initials {
          font-size: 12px;
        }
      }

      &--name {
        font-size: 15px;
        font-weight: 600;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 7px 0 1px;

        @include sm-and-down {
          margin: 4px 0 1px;
        }
      }

      &--email {
        font-size: 13px;
        color: $grey-color-6;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      @include sm-and-down {
        &--name {
          font-size: 11.3px;
        }

        &--email {
          font-size: 9.8px;
        }
      }
    }

    &__matter {
      position: absolute;
      height: 20%;
      width: 46%;
      top: 45%;
      left: 43%;
      font-weight: 600;
      font-size: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &--icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        border-radius: 50px;
        margin-inline-end: 5px;
        background-color: $navy-color-1;

        i {
          color: $white-color-1;
          font-size: 21px;
        }
      }

      @include sm-and-down {
        font-size: 11px;

        &--icon {
          width: 27px;
          height: 27px;

          i {
            font-size: 13px;
          }
        }
      }
    }
  }

  &__description {
    font-size: 13px;
    max-width: 380px;
    margin: auto;
  }
}
</style>
